import React from "react";

const PedidosIcon = () => (
  <svg
    style={{ color: "#0f0f0f", fontSize: "16px", width: "16px", height: "16px" }}
    viewBox="0 0 512 512"
    aria-hidden="true"
  >
    <path d="M384 80H128a48 48 0 0 0-48 48v256a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V128a48 48 0 0 0-48-48Zm-32 240H160a16 16 0 0 1 0-32h192a16 16 0 0 1 0 32Zm0-80H160a16 16 0 0 1 0-32h192a16 16 0 0 1 0 32Zm0-80H160a16 16 0 0 1 0-32h192a16 16 0 0 1 0 32Z" />
  </svg>
);

export default PedidosIcon;
